import axios from './index';

class SavingsPlanStoreApi {
  static List = (data) => {
    let query = '?';
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    if (data.selectedCompany) {
      query += `company_id=${data.selectedCompany.value}&`;
    }
    return axios.get(`${base}/${query}`);
  };

  static Create = (data) => {
    // let request = {
    //   name: data.name,
    //   metal_type: data.type,
    //   category: data.category,
    //   short_details: { text: data.description },
    //   display_order: Number(data.order),
    //   is_active: data.status === 'true' ? true : false,
    // };
    return axios.post(`${base}/`, data);
  };

  static Update = (data) => {
    console.log('data :: ', data);
    let request = {};
    if (data.name) request.name = data.name;
    if (data.type) request.metal_type = data.type;
    if (data.display_order) request.display_order = data.display_order;
    if (data.category) request.category = data.category;
    if (data.order) request.display_order = Number(data.order);
    if (data.description) request.short_details = { text: data.description };
    if (data.isActive)
      request.is_active = data.isActive === 'true' ? true : false;
    return axios.put(`${base}/${data.id}`, request);
  };

  static Delete = (data) => {
    return axios.delete(`${base}/${data.id}`);
  };
}

let base = 'dashboard/saving-plan-store';

export default SavingsPlanStoreApi;
